module.exports = __webpack_public_path__ + "static/media/chevron-left-active.8c2574a5.svg";